import type { Address, Tag } from './common';
import type { Company } from './company';

export enum CONNECT_EVENTS {
  applied_by_worker = 'applied_by_worker',
  applied_by_employer = 'applied_by_employer',
  declined_by_employer = 'declined_by_employer',
  declined_by_worker = 'declined_by_worker',
  connected_by_employer = 'connected_by_employer',
  connected_by_worker = 'connected_by_worker',
}

export interface Connection {
  event: string;
  message: string;
  status: string;
  uuid: string;
}

export interface Job {
  contact_email: string;
  contact_name: string;
  contact_phone: string;
  description: string;
  duration: number;
  duration_type: string;
  job_type: string;
  name: string;
  number_of_workers: number;
  overtime_from: number;
  overtime_to: number;
  overtime_type: string;
  qualifications_required: string[];
  salary_from: number;
  salary_to: number;
  salary_type: string;
  start_date: string;
  status: string;
  tags: Tag[];
  urgently: boolean;
  uuid: string;
  job_id?: string;
  years_of_experience: number;
  computed: {
    connection: Connection;
    distance: {
      value: number;
      type: string;
    };
  };
  address: Address;
  company?: Company;
  updated_at?: string;
  created_at?: string;
}
